import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'

import { updateCustomer } from '../actions/customers'
import LicenseTypeIcon from './LicenseTypeIcon';

class CustomerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        customer: '',
        group: '',
        country: '',
        type: '',
        licenseType: '',
      },
    };

    this.handleWhatsAppToggle = this.handleWhatsAppToggle.bind(this);
    this.handleSMSToggle = this.handleSMSToggle.bind(this);
  }
  goTo(id, e) {
    history.push(`/customers/${id}`)
  }

  handleFilterChange(filterKey, value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: value,
      },
    }));
  }

  handleWhatsAppToggle(customer, e) {
    e.stopPropagation();
    const { updateCustomer } = this.props;
    const newValue = !customer.WhatsAppCommunications;
    updateCustomer(customer._id, { WhatsAppCommunications: newValue });
  }

  handleSMSToggle(customer, e) {
    e.stopPropagation();
    const { updateCustomer } = this.props;
    const newValue = !customer.SMSCommunications;
    updateCustomer(customer._id, { SMSCommunications: newValue });
  }

  render() {
    const { filters } = this.state;
    const { customers } = this.props;

    // Apply the filters to filter the customers array
    const filteredCustomers = customers.filter(customer => {
      const { customer: customerFilter, group: groupFilter,
        country: countryFilter, mode: modeFilter, type: typeFilter, licenseType: licenseTypeFilter } = filters;

      if (
        customerFilter &&
        (!customer.Fullname ||
          !customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        groupFilter &&
        (!customer.Group ||
          !customer.Group.toLowerCase().includes(groupFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        countryFilter &&
        (!customer.Country || // Check if the Country property exists
          !customer.Country.toLowerCase().includes(countryFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        modeFilter &&
        (!customer.BusinessModel ||
          !customer.BusinessModel.toLowerCase().includes(modeFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        typeFilter &&
        (!customer.Type ||
          !customer.Type.toLowerCase().includes(typeFilter.toLowerCase()))
      ) {
        return false;
      }

      if (
        licenseTypeFilter &&
        (!customer.LicenseType || customer.LicenseType !== licenseTypeFilter)
      ) {
        return false;
      }
      // If all conditions pass, include the customer in the filtered list
      return true;
    });


    if (!this.props.customers) {
      return null
    }

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Nombre completo</th>
              <th scope="col">Licencia</th>
              <th scope="col">Grupo</th>
              <th scope="col">País</th>
              <th scope="col">Teléfono</th>
              <th scope="col">E-Mail</th>
              <th scope="col">Modo</th>
              <th scope="col">Tipo</th>
              <th scope="col">WhatsApp</th>
              <th scope="col">SMS</th>
            </tr>
            <tr>
              <th scope="col">
                <input
                  type="text"
                  placeholder="Cliente"
                  value={filters.customer}
                  onChange={e => this.handleFilterChange('customer', e.target.value)}
                />
              </th>
              <th scope="col">
                <select
                  value={filters.licenseType}
                  onChange={e => this.handleFilterChange('licenseType', e.target.value)}
                >
                  <option value="">Todas</option>
                  <option value="BASIC">Básica</option>
                  <option value="PRO">Pro</option>
                </select>
              </th>
              <th scope="col">
                <input
                  type="text"
                  placeholder="Grupo"
                  value={filters.group}
                  onChange={e => this.handleFilterChange('group', e.target.value)}
                />
              </th>
              <th scope="col">
                <input
                  type="text"
                  placeholder="País"
                  value={filters.country}
                  onChange={e => this.handleFilterChange('country', e.target.value)}
                />
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col">
                <select
                  value={filters.mode}
                  onChange={e => this.handleFilterChange('mode', e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="REVENUE SHARE">REVENUE SHARE</option>
                  <option value="SPACE RENTAL">SPACE RENTAL</option>
                  <option value="SALE">VENTA</option>
                  <option value="RENTAL">ALQUILER</option>
                </select>
              </th>
              <th scope="col">
                <select
                  value={filters.type}
                  onChange={e => this.handleFilterChange('type', e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="LICENCIA_BASICA">LICENCIA BÁSICA</option>
                  <option value="LICENCIA_PRO">LICENCIA PRO</option>
                  <option value="GROUP">GROUP</option>
                </select>
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {filteredCustomers
              .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
              .map(customer => {
                if (customer.Type === "GENERAL" || customer.Type === "LICENCIA_BASICA" || customer.Type === "LICENCIA_PRO" || customer.Type === "GROUP") {
                  return (
                    <tr key={customer._id}
                      onClick={e => this.goTo(customer._id, e)}>
                      <td>{customer.Fullname}</td>
                      <td>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <LicenseTypeIcon type={customer.Type === 'LICENCIA_PRO' ? 'PRO' : 'BASIC'} />
                          {customer.Type === 'LICENCIA_PRO' ? 'Pro' : 'Básica'}
                        </span>
                      </td>
                      <td>{customer.Group}</td>
                      <td>{customer.Country}</td>
                      <td>{customer.Phone}</td>
                      <td>{customer.Email}</td>
                      <td>{customer.BusinessModel}</td>
                      <td>{customer.Type}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <div
                          onClick={(e) => this.handleWhatsAppToggle(customer, e)}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: customer.WhatsAppCommunications ? '#28a745' : '#dc3545',
                            borderRadius: '25px',
                            padding: '4px',
                            cursor: 'pointer',
                            width: '80px',
                            height: '32px',
                            position: 'relative',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                          }}
                          title={customer.WhatsAppCommunications ? 'Click para deshabilitar' : 'Click para habilitar'}
                        >
                          <div
                            style={{
                              position: 'absolute',
                              backgroundColor: 'white',
                              borderRadius: '50%',
                              width: '24px',
                              height: '24px',
                              transition: 'transform 0.3s ease',
                              transform: customer.WhatsAppCommunications ? 'translateX(50px)' : 'translateX(2px)',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                            }}
                          />
                          <span
                            style={{
                              color: 'white',
                              fontSize: '11px',
                              fontWeight: 'bold',
                              position: 'absolute',
                              left: customer.WhatsAppCommunications ? '8px' : 'auto',
                              right: customer.WhatsAppCommunications ? 'auto' : '8px',
                              userSelect: 'none',
                            }}
                          >
                            {customer.WhatsAppCommunications ? 'SÍ' : 'NO'}
                          </span>
                        </div>
                      </td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <div
                          onClick={(e) => this.handleSMSToggle(customer, e)}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: customer.SMSCommunications ? '#28a745' : '#dc3545',
                            borderRadius: '25px',
                            padding: '4px',
                            cursor: 'pointer',
                            width: '80px',
                            height: '32px',
                            position: 'relative',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                          }}
                          title={customer.SMSCommunications ? 'Click para deshabilitar' : 'Click para habilitar'}
                        >
                          <div
                            style={{
                              position: 'absolute',
                              backgroundColor: 'white',
                              borderRadius: '50%',
                              width: '24px',
                              height: '24px',
                              transition: 'transform 0.3s ease',
                              transform: customer.SMSCommunications ? 'translateX(50px)' : 'translateX(2px)',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                            }}
                          />
                          <span
                            style={{
                              color: 'white',
                              fontSize: '11px',
                              fontWeight: 'bold',
                              position: 'absolute',
                              left: customer.SMSCommunications ? '8px' : 'auto',
                              right: customer.SMSCommunications ? 'auto' : '8px',
                              userSelect: 'none',
                            }}
                          >
                            {customer.SMSCommunications ? 'SÍ' : 'NO'}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )
                }
              })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default connect(null, { updateCustomer })(CustomerList)